export type ConfiguracaoObservabilidade =
  | Readonly<{ destino: 'desativado' }>
  | Readonly<{ destino: 'console'; ambiente: 'local'; release: string }>
  | Readonly<{ destino: 'apm'; ambiente: 'producao'; release: string; dsn: string }>

export type EntradaConfiguracaoObservabilidade = Readonly<{
  ambiente?: string | undefined
  habilitado?: boolean | undefined
  dsn?: string | undefined
  release?: string | undefined
}>

export const configurarObservabilidade = (
  entrada: EntradaConfiguracaoObservabilidade,
): ConfiguracaoObservabilidade => {
  if (entrada.habilitado === false) return { destino: 'desativado' }
  // Release é um identificador de artefato, nunca texto de usuário.
  const release = /^[a-zA-Z0-9._-]{1,100}$/.test(entrada.release ?? '')
    ? entrada.release ?? 'local'
    : undefined
  if (entrada.ambiente === 'local') {
    return { destino: 'console', ambiente: 'local', release: release ?? 'local' }
  }
  const ambiente = entrada.ambiente
  if (ambiente !== 'producao' || entrada.habilitado !== true || !release) {
    return { destino: 'desativado' }
  }
  try {
    const dsn = new URL(entrada.dsn ?? '')
    if (dsn.protocol !== 'https:' || !/^[a-zA-Z0-9_-]+$/.test(dsn.username)
      || dsn.password || dsn.search || dsn.hash || !/^\/\d+$/.test(dsn.pathname)) {
      return { destino: 'desativado' }
    }
    return { destino: 'apm', ambiente, release, dsn: dsn.toString() }
  } catch {
    return { destino: 'desativado' }
  }
}
